import React from 'react';
import { toast } from 'react-toastify';
import { call, put } from 'redux-saga/effects';

import { Creators as WebhookEventIntegration } from '../ducks/webhookEventIntegration';

import { WebhookEventIntegrationAPI } from '../../services/api';

import { ErrorToast } from '../../components/molecules/Toast';

export function* getWebhookEventList(action) {
  const { webhookId } = action.payload;
  try {
    const response = yield call(
      WebhookEventIntegrationAPI.get,
      `/list/${webhookId}`
    );
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookEventIntegration.getWebhookEventsListResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    WebhookEventIntegration.getWebhookEventsListResponse({}, false);
  }
}

export function* postWebhookEvent(action) {
  const { params } = action.payload;
  try {
    const response = yield call(
      WebhookEventIntegrationAPI.post,
      `/post`,
      params
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      WebhookEventIntegration.postWebhookEventIntegrationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventIntegration.postWebhookEventIntegrationResponse([], false)
    );
    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}

export function* deleteWebhookEvent(action) {
  const idWebhookEvent = action.payload;
  try {
    const response = yield call(
      WebhookEventIntegrationAPI.delete,
      `${idWebhookEvent}`
    );

    const isSuccess = response.status === 200 || false;

    yield put(
      WebhookEventIntegration.deleteWebhookEventIntegrationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(
      WebhookEventIntegration.deleteWebhookEventIntegrationResponse({}, false)
    );
    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}
export function* putWebhookEvent(action) {
  const { params } = action.payload;
  try {
    const response = yield call(WebhookEventIntegrationAPI.put, `/put`, params);
    const isSuccess = response.status === 200 || false;
    yield put(
      WebhookEventIntegration.putWebhookEventIntegrationResponse(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    WebhookEventIntegration.putWebhookEventIntegrationResponse({}, false);

    if (error.status === 500) {
      toast.error(
        <ErrorToast size="30">{error.response.data.error_message}</ErrorToast>
      );
    }

    toast.error(<ErrorToast size="30">{error.response.data}</ErrorToast>);
  }
}
